import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-security-privacy',
  templateUrl: './landing-security-privacy.component.html',
  styleUrls: ['../landing/landing.component.scss', './landing-security-privacy.component.scss']
})
export class LandingSecurityPrivacyComponent {

}
